import axios, { AxiosRequestConfig } from 'axios';
import { DataResponse } from '../types/api';

const URL = '/v2/background-check-request';

class BackgroundCheckRequestService {
  static create(
    id: number,
    config?: AxiosRequestConfig
  ): Promise<DataResponse<{ id: number }>> {
    return axios.post(URL, { id }, config);
  }
}

export { BackgroundCheckRequestService };
